export default __webpack_public_path__ + "static/media/applications-image-29.8e02c4d5.jpg";